import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../../components/layout';
import Header from '../../../components/header';
import Button from '../../../components/elements/button';
import ViewStockpicking from '../StockPicking/_components/viewStockpicking';
import Drawer from '../../../components/Drawer';
import CreateStockpicking from '../StockPicking/_components/createStockpicking';
import { Dropdown, Menu } from '../../../components/Dropdown';
import Pagination from '../../../components/pagination';
import Search from '../../../components/search';
import Icon from '../../../components/icons';
import Filters from '../../../components/filters';
import { filterConfigType } from '../../../_config/types';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import toast from 'react-hot-toast';
import CreateStockpickingWO from './_components/createStockpickingWO';
import { AgGridReact } from 'ag-grid-react';
import Loader from '../../../components/loader';
import ReturnStockModal from './_components/returnStock.modal';
import { useCycleCountApi } from '../../../store/api/hooks/cycleCountApiHook';
import { PAGE_SIZE } from '../../../_common/constant';
import { useSpearPartsApi } from '../../../store/api/hooks/spearPartsApiHook';
import { downloadExcel, downloadPDF, getPermissionInfo } from '../../../_common/functions';
import { useLocation } from 'react-router-dom';
import { useUserSelector } from '../../../store/selectors/userSelector';
import { useCommonApi } from '../../../store/api/hooks/commonApiHook';

const StockPickingNew: React.FC = () => {

    const newSPRef: any = useRef();
    const newSPContentRef: any = useRef();
    const newSPWORef: any = useRef();
    const newSPWOContentRef: any = useRef();
    const filtersRef: any = useRef();
    const cycleCountAPI = useCycleCountApi();
    const spearPartsAPI = useSpearPartsApi();
    const location = useLocation();
    const loggedinuser: any = useUserSelector();

    const facilityApi: any = useFacilitiesApi();

    const [selectedSP, setSelectedSP] = useState<any>(null);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false });
    const [filters, setFilters] = useState<any>({});
    const [facilityoption, setFacilityoption] = useState<any>([]);
    const [rowData, setRowData] = useState<any>(null);
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const stockRef = useRef<HTMLDialogElement>(null);
    const [selectedSPForReturn, setSelectedSPForReturn] = useState<any>(null);
    const [isRemainingQtyFilter, setIsRemainingQtyFilter] = useState<boolean>(true);
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('stockPickingNewFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('stockPickingNewFilters', JSON.stringify(filters));
        }
    }, [filters]);

    const getSpearPartsList = (s: string) => {
        return new Promise((resolve, reject) => {
            let payload: any = {};
            if (s !== '') {
                payload.searchParam = s;
            }

            spearPartsAPI.getSpearPartsList(payload, (resp: any) => {
                resolve(resp.sparePartsList ? resp.sparePartsList.map((part: any) => {
                    return {
                        label: part.sparePartsName,
                        value: part.partsID,
                    };
                }) : []);
            }, (error: any) => { reject(false) });
        });
    };
    const commonApi: any = useCommonApi();
    const getUserList = (s: string) => {
        return new Promise((resolve, reject) => {
            let payload: any = {};
            if (s !== '') {
                payload.searchParam = s;
                payload.pageSize = 0;
            }

            commonApi.GetUserList(payload, (resp: any) => {
                resolve(resp.userList ? resp.userList.map((user: any) => {
                    return {
                        label: user.firstName + " " + user.lastName,
                        value: user.userID,
                    };
                }) : []);
            }, (error: any) => { reject(false) });
        });
    }

    const filterConfig: filterConfigType[] = [
        { name: 'Part Name', type: 'dropdown', key: 'partIDs', async: getSpearPartsList as any },
        { name: 'User', type: 'dropdown', key: 'pickedByIDs', async: getUserList as any },
    ];

    const columnDefs = [
        {
            headerCheckboxSelection: true,
            checkboxSelection: true,
            maxWidth: 50,
            flex: 0,
            headerClass: 'bg-[#f0f0f0]',
        },
        {
            headerName: 'User',
            field: 'pickedByName',
            flex: 1,
            headerClass: 'bg-[#f0f0f0]',
        },
        {
            headerName: 'Part Code',
            field: 'partsCode',
            flex: 1,
            headerClass: 'bg-[#f0f0f0]',
        },
        {
            headerName: 'Part Name',
            field: 'partsName',
            flex: 1,
            headerClass: 'bg-[#f0f0f0]',
        },
        {
            headerName: 'Qty Picked',
            field: 'totalPickedQuantity',
            flex: 1,
            headerClass: 'bg-[#f0f0f0]',
        },
        {
            headerName: 'Qty Used',
            field: 'totalUsedQuantity',
            flex: 1,
            headerClass: 'bg-[#f0f0f0]',
        },
        {
            headerName: 'Returned Qty',
            field: 'totalReturnedQuantity',
            flex: 1,
            headerClass: 'bg-[#f0f0f0]',
        },
        {
            headerName: 'Qty Remaining',
            field: 'totalRemainingQuantity',
            flex: 1,
            headerClass: 'bg-[#f0f0f0]',
        },
        {
            headerName: 'Returning Qty',
            field: 'returningQty',
            flex: 1,
            headerClass: 'bg-[#f0f0f0]',
            cellRenderer: (params: any) => {
                const maxQty = Number(params.data?.totalRemainingQuantity ?? params.data?.totalRemainingQuantity ?? 0);
                const returningQty = params.value ?? 0;

                return (
                    <input
                        type="tel"
                        className={`w-full border ${Number(returningQty) > maxQty ? 'border-red-500' : 'border-gray-300'
                            } rounded px-2 py-[0.3rem] text-sm outline-none focus:border-gray-300 focus:ring-0`}
                        value={returningQty}
                        onChange={(e) => {
                            let input = e.target.value;
                            if (!/^\d*$/.test(input)) return;
                            if (input === '') {
                                params.node.setDataValue('returningQty', 0);
                                params.node.setSelected(false);
                                return;
                            }
                            const newQty = Number(input);
                            if (newQty > maxQty) {
                                toast.error(`Returning Qty cannot exceed Qty Remaining (${maxQty})`);
                                params.node.setDataValue('returningQty', 0);
                                params.node.setSelected(false);
                                return;
                            }
                            params.node.setDataValue('returningQty', newQty);
                            params.node.setSelected(newQty > 0);
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                );
            },
            suppressKeyboardEvent: () => true,
        },
        {
            headerName: 'Actions',
            field: 'actions',
            flex: 1,
            headerClass: 'bg-[#f0f0f0]',

            cellRenderer: (params: any) => {
                return (
                    <div className='flex items-center gap-2 py-1.5'>
                        <Button theme='primary' size='sm' className='!py-1 leading-4' onClick={(e) => {
                            e.stopPropagation();
                            setSelectedSPForReturn([params.data]);
                            stockRef.current?.showModal();
                        }}>Return Stock</Button>
                    </div>
                );
            }
        }
    ];


    const GetStockPickingList = () => {
        let payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
            isRemainingQtyFilter: isRemainingQtyFilter,
        };
        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key] && filters[key] !== '') {
                    payload[key] = filters[key];
                }
            });
        }
        setRowData(null)
        cycleCountAPI.GetStockPickingList(payload, (resp: any) => {
            console.log('Cycle Count List', resp);
            setRowData(resp.stockPickList ? resp.stockPickList : []);
            setTotalRecords(resp.totalRecord);
        }, (error: any) => {
            setRowData([]);
            setTotalRecords(0);
        });
    };

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };

    const onBulkExportPdf = () => {
        if (!getPermissionInfo(location.pathname, "Export", loggedinuser)) {
            toast.error("You don't have Export permission");
            return;
        }

        const payload: any = {};
        const selectedData = getSelectedRows();
        if (selectedData.length == 0) {
            payload.partIDs = '';
            payload.pickedByIDs = '';
        } else {
            const partsID = selectedData.map((sp: any) => sp.partsID).join(',');
            const pickedByIDs = selectedData.map((sp: any) => sp.pickedByID).join(',');
            payload.partIDs = partsID;
            payload.pickedByIDs = pickedByIDs;

        }
        cycleCountAPI.ExportPickingToPDF(
            payload,
            (resp: any) => {
                downloadPDF(resp, 'stock_picking');
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const onBulkExportCsv = async () => {
        if (!getPermissionInfo(location.pathname, "Export", loggedinuser)) {
            toast.error("You don't have Export permission");
            return;
        }
        const payload: any = {};
        const selectedData = getSelectedRows();
        if (selectedData.length == 0) {
            payload.partIDs = '';
            payload.pickedByIDs = '';
        } else {
            const partsID = selectedData.map((sp: any) => sp.partsID).join(',');
            const pickedByIDs = selectedData.map((sp: any) => sp.pickedByID).join(',');
            payload.partIDs = partsID;
            payload.pickedByIDs = pickedByIDs;

        }

        cycleCountAPI.ExportPickingToXLS(
            payload,
            (resp: any) => { downloadExcel(resp, 'stock_picking') },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    useEffect(() => {
        if (filtersInitialized) {
            GetStockPickingList();
        }

        const hasActiveFilters = filterConfig.some((filter) => {
            const filterValue = filters[filter.key];
            return filterValue !== null && filterValue !== undefined && filterValue !== '' &&
                (Array.isArray(filterValue) ? filterValue.length > 0 : true);
        });
        setFiltersApplied({
            generalFilter: hasActiveFilters,
        });
    }, [currentPage, searchParam, filters, isRemainingQtyFilter, filtersInitialized]);

    return (
        <Layout>
            <Header title='Stock Picking'>
                <Header.Right>
                    <Drawer _ref={newSPWORef} isAfterOpenRender={true} onClose={() => {
                        newSPContentRef?.current?.reset()
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button disabled={!getPermissionInfo(location.pathname, "Stock Picking for Task", loggedinuser)}>New Stock Picking for Task</Button>
                        </Drawer.Button>
                        <Drawer.Content title={`Create New Stock Picking for Task`} className='!w-[53rem]'>
                            {!getPermissionInfo(location.pathname, "Add", loggedinuser) ? (
                                <div className="p-4 text-red-500">
                                    You don't have permission to access this form.
                                </div>
                            ) : (
                                <CreateStockpickingWO _ref={newSPWOContentRef} editData={null} onCreate={() => {
                                    GetStockPickingList();
                                    newSPWORef?.current?.close();
                                }} onCancel={() => {
                                    newSPWORef?.current?.close();
                                }} />
                            )}
                        </Drawer.Content>
                    </Drawer>

                    <Drawer _ref={newSPRef} onClose={() => {
                        setSelectedSP(null);
                        newSPContentRef?.current?.reset()
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button theme={`light`} className={`border-[#2b5a2e]`} disabled={!getPermissionInfo(location.pathname, "Add", loggedinuser)}>New Stock Picking</Button>
                        </Drawer.Button>
                        <Drawer.Content title={selectedSP ? 'View Stock Picking' : (selectedSP ? 'Stock Picking' : 'Create New Stock Picking')} className='!w-[39.563rem]'>
                            {selectedSP ? (
                                <ViewStockpicking _ref={newSPContentRef} viewData={selectedSP} onCreate={() => {
                                    setSelectedSP(null);
                                    GetStockPickingList();
                                    newSPRef?.current?.close();
                                }} onCancel={() => {
                                    setSelectedSP(null);
                                    newSPRef?.current?.close();
                                }} />
                            ) : !getPermissionInfo(location.pathname, "Add", loggedinuser) ? (
                                <div className="p-4 text-red-500">
                                    You don't have permission to access this form.
                                </div>
                            ) : (
                                <CreateStockpicking _ref={newSPContentRef} editData={selectedSP} onCreate={() => {
                                    setSelectedSP(null);
                                    GetStockPickingList();
                                    newSPRef?.current?.close();
                                }} onCancel={() => {
                                    setSelectedSP(null);
                                    newSPRef?.current?.close();
                                }} />
                            )}
                        </Drawer.Content>
                    </Drawer>

                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary'>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportPdf}>Export pdf</Menu>
                        </Dropdown.Content>
                    </Dropdown>
                </Header.Right>
            </Header>
            <div>
                <div className='flex items-center justify-between px-3 border-b border-gray-200 h-[3.75rem]'>
                    <Pagination perPage={PAGE_SIZE} totalRecords={totalRecords} onPageChange={setCurrentPage} currentPage={currentPage} />
                    {/* <Search onSearch={setSearchParam} /> */}
                </div>
                <div className='bg-[#FAFAFA]'>

                    <div className='flex items-center justify-between'>
                        <div className='flex gap-4 px-5 py-2 items-center'>
                            <Button theme='light' onClick={() => filtersRef.current.showModal()}>
                                Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} />
                            </Button>
                            <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => {
                                setFilters({});
                                localStorage.removeItem('stockPickingNewFilters');
                            }} >Clear Filters</p>
                        </div>
                        <div className='flex items-center gap-2'>
                            <input type="checkbox" checked={isRemainingQtyFilter} onChange={(e) => { setIsRemainingQtyFilter(e.target.checked) }} className='w-4 h-4 accent-gray-600' /> Remaining Quantity
                        </div>
                    </div>

                    <div className="ag-theme-alpine mx-4  h-1/2">
                        <AgGridReact
                            columnDefs={columnDefs}
                            rowData={rowData || []}
                            rowSelection="multiple"
                            pagination={false}
                            domLayout="autoHeight"
                            onGridReady={onGridReady}
                            suppressRowClickSelection={true}
                            loadingOverlayComponent={Loader}
                            noRowsOverlayComponent={() => (
                                <div className="flex items-center justify-center h-full">
                                    <div className="text-center text-gray-500">
                                        <div className="text-lg font-medium">No Data Found</div>
                                    </div>
                                </div>
                            )}
                        />
                    </div>
                </div>

                {/* Add your component code here */}
                <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={(data) => {
                    console.log('On Submit Filters =>', data);
                    setFilters(data);
                }} />
                <ReturnStockModal
                    _ref={stockRef}
                    data={selectedSPForReturn}
                    onUpdate={() => {
                        setSelectedSPForReturn(null);
                        stockRef.current?.close();
                        GetStockPickingList();
                    }}
                    onCancel={() => {
                        setSelectedSPForReturn(null);
                        stockRef.current?.close();
                    }}
                />
            </div>
        </Layout>
    );
};

export default StockPickingNew;